<script setup lang="ts">
const currentAlgoliaIndex = useAppConfig().currentAlgoliaIndex
const { state } = useAisWidget('sortBy')
const { getInstance } = useInstantSearch()
const instance = getInstance()

const resetFiltersAndSorting = () => {
  instance.value.helper!.clearRefinements().search()
}
</script>

<template>
  <div>
    <AisClearRefinements>
      <template #default="">
        <AtomsCta anatomy="link" @click.prevent="resetFiltersAndSorting()">
          <template #label>
            {{ $ts('plp.filtersSideSlide.resetFilters') }}
          </template>
        </AtomsCta>
      </template>
    </AisClearRefinements>
  </div>
</template>
